import React from "react";

const learningPaths = [
  {
    title: "Personalized Learning",
    description: "Tailored education built around your growth goals:",
    features: [
      "Skill assessment and growth mapping",
      "Customized learning pathways",
      "Progress tracking and milestones",
      "Adaptive content recommendations",
      "1-on-1 coaching sessions"
    ]
  },
  {
    title: "Live Training",
    description: "Hands-on skill development with guided practice:",
    features: [
      "Live interactive workshops",
      "Hands-on project development",
      "Industry-standard tools and platforms",
      "Real-world case studies",
      "Peer collaboration and networking"
    ]
  },
  {
    title: "Portfolio Support",
    description: "Structured guidance for professional growth:",
    features: [
      "Interview preparation and mock sessions",
      "Resume and LinkedIn refinement",
      "Portfolio project reviews",
      "Communication coaching",
      "Continued learning support"
    ]
  }
];

const RealWorldLearning = () => (
  <section className="py-20 px-4" style={{ backgroundColor: '#F1EFED' }}>
    <div className="w-full h-px bg-gray-300 mb-20"></div>

    <div className="max-w-7xl mx-auto">
      <div className="text-center mb-16">
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
          End-to-end platform for the full <br />
          <span className="text-blue-600">career transformation</span> lifecycle
        </h2>
        <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
          Leverage personalized learning paths, hands-on projects, and expert mentorship to accelerate your career.
          1to10x offers a seamless continuum of learning and support solutions for your professional journey.
        </p>
      </div>

      <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
        {learningPaths.map((path, idx) => (
          <li key={idx} className="rounded-xl p-6 sm:p-8 border border-gray-300 shadow-sm" style={{ backgroundColor: '#F1EFED' }}>
            <div className="mb-4 sm:mb-6">
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900">{path.title}</h3>
            </div>

            <div className="mb-4 sm:mb-6">
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{path.description}</p>
            </div>

            <ul className="space-y-2 sm:space-y-3">
              {path.features.map((feature, featureIdx) => (
                <li key={featureIdx}>
                  <p className="text-sm sm:text-base text-gray-700 leading-relaxed">{feature}</p>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default RealWorldLearning;
